<div class="modal-backdrop">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        @if (image?.extension === 'pdf') {
          <ngx-extended-pdf-viewer [base64Src]="image.imageData" useBrowserLocale="true" height="70vh"></ngx-extended-pdf-viewer>
        } @else {
          @if (src) {
            <ap-image-viewer [src]='src' [alt]='image.imageName' [extension]='image.extension'></ap-image-viewer>
          }
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary close_button" (click)="confirm()">Fermer</button>
      </div>
    </div>
  </div>
</div>
